import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { Issue } from '@/api/types/backend-dto-types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetSubsetIssues = (matterId?: string, subsetId?: string) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<Issue[]>(
    [QueryEntity.SubsetIssues, { matterId, subsetId }],
    async () => {
      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/issues`,
        fetchConfigGET,
      );
      if (!response.ok) throw new Error('Failed to fetch subset issues');
      return response.json();
    },
    { enabled: !!matterId && !!subsetId },
  );
};
